// extracted by mini-css-extract-plugin
export default {"place":"ContactInformation_place__8-x9t","email":"ContactInformation_email__EDAgG","phone":"ContactInformation_phone__mQpRi","info":"ContactInformation_info__jiAOv"};